import { ICompleteCheckSmsReqParams, IJoinRequestParams } from '@/core/domain/entities/request';
import { errorCodes } from '@/services/api/errorCodes';
import {
  completeCheckSms,
  getCountry,
  join,
  validateNicknameUniqueness,
  validatePhoneNumberUniqueness,
} from '@/services/api/UserApi';

/**
 * 전화번호 중복 체크
 * @param {string} phone
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function checkUniquePhoneNumber(
  phone: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await validatePhoneNumberUniqueness(phone);
    console.log('ret', ret);

    if (ret.status === 'error') {
      return { succed: false, errorProcceded: true, errorMessage: ret.errorMessage };
    } else {
      return { succed: true };
    }
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 닉네임 중복 체크
 * @param {string} name
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryCheckUniqueNickname(
  name: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await validateNicknameUniqueness(name);

    if (ret.status === 'error') {
      return { succed: false, errorProcceded: true, errorMessage: ret.errorMessage };
    } else {
      return { succed: true };
    }
  } catch (error) {
    console.error(error);
    return { succed: false, errorProcceded: true, errorMessage: '닉네임 중복 체크 실패' };
  }
}

/**
 * 인증번호 체크
 * @param {ICompleteCheckSmsReqParams} reqData
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryCompleteCheckSms(
  reqData: ICompleteCheckSmsReqParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await completeCheckSms(reqData);
    const errorInfo = errorCodes.find((error) => error.code === ret);

    if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 국가 조회
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function fetchCountry(): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    await getCountry();

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 회원가입
 * @param {IJoinRequestParams} reqData
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryJoin(
  reqData: IJoinRequestParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string; errorCode?: string }> {
  try {
    const res = await join(reqData);

    if (res.errorCode === '3000') {
      return {
        succed: false,
        errorProcceded: true,
        errorMessage: '솔라나 지갑 활성에 실패하였습니다.\n관리자에게 문의해주세요.',
        errorCode: res.errorCode,
      };
    }

    if (res.status === 'error') {
      return { succed: false, errorProcceded: true, errorMessage: res.message };
    } else {
      return { succed: true };
    }

    // const errorInfo = errorCodes.find((error) => error.code === res);
    // console.log('errorInfo', errorInfo);

    // if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}
